import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Axios from 'axios'
import config from 'services/config'
import _ from 'lodash'
Vue.use(VueI18n)

const INSTANCE_LANGUAGE = config.appLanguage

if (!localStorage.getItem('totemLocale')) {
    localStorage.setItem('totemLocale', INSTANCE_LANGUAGE)
}

function getURLLocales () {
    const urlLocales = {}
    let locale = require('@/../translations/' + INSTANCE_LANGUAGE + '.json')
    for (const translationKey in locale[INSTANCE_LANGUAGE]['totem']) {
        if (!isTranslationKeyAnURL(translationKey)) {
            continue
        }
        urlLocales[translationKey] = locale[INSTANCE_LANGUAGE]['totem'][translationKey]
    }
    return {
        [INSTANCE_LANGUAGE]: urlLocales
    }
}

function isTranslationKeyAnURL (key) {
    return key.includes('Url.') || key.includes('General.start_trial_url_slug')
}

async function fetchTranslationsFromAesir () {
    const promises = [];
    ['trial-forms', 'totem'].forEach(context => {
        const url = `${config.aesirUrl}/api/translations/${context}`.replace(/\/$/, '')
        promises.push(Axios.get(url, {
            withCredentials: true
        }))
    })
    const translationsResult = await Promise.all(promises)

    return translationsResult.map(({ data }) => data).reduce((merged, current) => _.merge(merged, current), {})
}

export async function loadRemoteLocaleMessages () {
    const fetchedLocales = await fetchTranslationsFromAesir()
    for (const language in fetchedLocales) {
        let messages = {
            ...fetchedLocales[language]['totem'],
            ...fetchedLocales[language]['trial-forms']
        }
        if (language !== INSTANCE_LANGUAGE) {
            messages = removeUrlTranslations(messages)
        }
        i18n.setLocaleMessage(language, messages)
    }
}

function removeUrlTranslations (locale) {
    return filterObjectByKey(locale, key => !isTranslationKeyAnURL(key))
}

function filterObjectByKey (input, filterCallback) {
    const filtered = Object
        .entries(input)
        .filter(([key, value]) => filterCallback(key))
    return Object.fromEntries(filtered)
}

const i18n = new VueI18n({
    locale: localStorage.getItem('totemLocale'),
    messages: getURLLocales(),
    fallbackLocale: INSTANCE_LANGUAGE,
    silentTranslationWarn: true
})

export default i18n
